import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your actual Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyCx7fxhYPfZ07ML7JPQ3SJrCO6z3v17FtE",
    authDomain: "event-hub-de139.firebaseapp.com",
    projectId: "event-hub-de139",
    storageBucket: "event-hub-de139.firebasestorage.app",
    messagingSenderId: "428099833982",
    appId: "1:428099833982:web:ad15defd220133801e482f",
    measurementId: "G-RH5QCK0B51"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export const googleClientId = "428099833982-vtc5gl2fc7git63n1helr9t1ethlcj74.apps.googleusercontent.com";
